import { useState, useEffect } from "react";
import { Brain, Dumbbell, Apple, ShoppingCart, Droplets, Flame, ChevronDown, Loader2 } from "lucide-react";

const EXERCISE_IMAGES = {
  "push": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/7495e1590fcde8fb2394c9b62ae817700d7c919696708cfe27ea2a869f779fc0.png",
  "squat": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/4c3f967dd205138ee7cd02eee3889e85749f92b96733939a79838e833d1d7fa6.png",
  "plank": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/1971ca810918d9148d0d9c29a302800ea55d8e1f5c6e8ba702dde7671a264620.png",
  "lunge": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/d956fb1780e6945f9d296561be9e7f10404beb19b866d8f888137fcf61d04fde.png",
  "deadlift": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/42bf30c2dbf507b88d8c79c905b4260a824531ab461a4d934f8feea2210f284a.png",
  "bench": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/eb91d0baf8263655db536cb8ac36211c3b44db288a0cdeaf3b7ba3e8e325ae78.png",
  "curl": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/5f92e454c65dea6c7ee7d018996c9e971f256b4f0bb237d09b34887d9c1f2e71.png",
  "jack": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/6db6acd5209fc3e29844a9e1d57f8a20a76065f77fd7cbd78a1d7d89993189f3.png",
  "burpee": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/15dd6abfdd60b3efdd2456f9b7abb80e18f4984b656869b16ba7848e3d228b45.png",
  "mountain": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/9940b741f670e93adcbbc05fd84a79eb86437a48a84720f4271df6f9be1a2834.png",
  "shoulder": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/c2bc78648636d088d49015676042eb54d26793f12752b452aba85ff933e16ae6.png",
  "crunch": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/aeefc5381857354ac262a40195f6fc314fbb78dff9e69c51ec7e2052b3d21625.png",
  "sit": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/aeefc5381857354ac262a40195f6fc314fbb78dff9e69c51ec7e2052b3d21625.png",
  "press": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/c2bc78648636d088d49015676042eb54d26793f12752b452aba85ff933e16ae6.png",
};
const DEFAULT_EXERCISE_IMG = "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/7495e1590fcde8fb2394c9b62ae817700d7c919696708cfe27ea2a869f779fc0.png";
const getExerciseImg = (name) => {
  const n = (name || "").toLowerCase();
  return Object.entries(EXERCISE_IMAGES).find(([key]) => n.includes(key))?.[1] || DEFAULT_EXERCISE_IMG;
};

const MEAL_IMAGES = {
  "breakfast": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/275ae200b98a6e259f9ccf6099ac5b663825d6ad97955f98a00a7c20689f775e.png",
  "lunch": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/f923b2a790236485759928f5033459cc3d8164bb97ab3bcdaced80ab8926d0d6.png",
  "dinner": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/d670594e49e50edbd60e3d71c35154f7da8cc0fae3ba89a1247ec31afce08b05.png",
  "snack": "https://static.prod-images.emergentagent.com/jobs/1097075e-32a9-4c88-942d-3d6dd2af456f/images/d3695039b6b73798f4db71608c59f81025080408772ec82a06c44e03c64dd01f.png",
};
const getMealImg = (type) => {
  const t = (type || "").toLowerCase();
  return Object.entries(MEAL_IMAGES).find(([key]) => t.includes(key))?.[1] || MEAL_IMAGES.lunch;
};
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Navbar } from "../components/Navbar";
import { ProtectedRoute } from "../components/ProtectedRoute";
import api from "../lib/api";

const VitaAIContent = () => {
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState(null);
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState({
    age: "",
    gender: "male",
    budget: "",
    health_goals: "",
    fitness_goal: "lose_weight",
    workout_location: "home",
  });

  useEffect(() => {
    api.get("/vita-ai/plans").then((r) => setPlans(r.data || [])).catch(() => {});
  }, []);

  const handleGenerate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPlan(null);
    try {
      const res = await api.post("/vita-ai/generate", {
        ...form,
        age: parseInt(form.age),
        budget: parseFloat(form.budget),
      });
      setPlan(res.data);
      // Refresh plans list
      api.get("/vita-ai/plans").then((r) => setPlans(r.data || [])).catch(() => {});
    } catch (err) {
      alert(err.response?.data?.detail || "Failed to generate plan");
    } finally {
      setLoading(false);
    }
  };

  const loadPlan = async (planId) => {
    try {
      const res = await api.get(`/vita-ai/plans/${planId}`);
      setPlan(res.data);
    } catch (err) { console.error('Error:', err.message || err); }
  };

  return (
    <div className="min-h-screen bg-transparent" data-testid="vita-ai-page">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-8">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="bg-[#0B6E4F] p-2.5 rounded-xl">
              <Brain className="h-6 w-6 text-white" />
            </div>
            <h1 className="font-['Outfit'] text-3xl md:text-4xl font-bold text-[#0F172A]">Vita AI</h1>
          </div>
          <p className="text-slate-500 ml-14">AI-powered personalized health & fitness plans</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Input Form */}
          <div className="lg:col-span-1">
            <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm sticky top-24">
              <h3 className="font-['Outfit'] text-lg font-semibold text-[#0F172A] mb-6">Your Profile</h3>
              <form onSubmit={handleGenerate} className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-sm font-medium text-slate-700">Age</Label>
                    <Input
                      data-testid="ai-age-input"
                      type="number"
                      placeholder="25"
                      value={form.age}
                      onChange={(e) => setForm({ ...form, age: e.target.value })}
                      className="mt-1 h-11 rounded-xl bg-slate-50"
                      required
                    />
                  </div>
                  <div>
                    <Label className="text-sm font-medium text-slate-700">Gender</Label>
                    <Select value={form.gender} onValueChange={(v) => setForm({ ...form, gender: v })}>
                      <SelectTrigger data-testid="ai-gender-select" className="mt-1 h-11 rounded-xl bg-slate-50">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="male">Male</SelectItem>
                        <SelectItem value="female">Female</SelectItem>
                        <SelectItem value="other">Other</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>

                <div>
                  <Label className="text-sm font-medium text-slate-700">Monthly Budget ($)</Label>
                  <Input
                    data-testid="ai-budget-input"
                    type="number"
                    placeholder="200"
                    value={form.budget}
                    onChange={(e) => setForm({ ...form, budget: e.target.value })}
                    className="mt-1 h-11 rounded-xl bg-slate-50"
                    required
                  />
                </div>

                <div>
                  <Label className="text-sm font-medium text-slate-700">Health Goals</Label>
                  <Input
                    data-testid="ai-goals-input"
                    placeholder="e.g., Better sleep, more energy"
                    value={form.health_goals}
                    onChange={(e) => setForm({ ...form, health_goals: e.target.value })}
                    className="mt-1 h-11 rounded-xl bg-slate-50"
                    required
                  />
                </div>

                <div>
                  <Label className="text-sm font-medium text-slate-700">Fitness Goal</Label>
                  <Select value={form.fitness_goal} onValueChange={(v) => setForm({ ...form, fitness_goal: v })}>
                    <SelectTrigger data-testid="ai-fitness-goal-select" className="mt-1 h-11 rounded-xl bg-slate-50">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="lose_weight">Lose Weight</SelectItem>
                      <SelectItem value="get_fit">Get Fit</SelectItem>
                      <SelectItem value="gain_muscle">Gain Muscle</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div>
                  <Label className="text-sm font-medium text-slate-700">Workout Location</Label>
                  <Select value={form.workout_location} onValueChange={(v) => setForm({ ...form, workout_location: v })}>
                    <SelectTrigger data-testid="ai-location-select" className="mt-1 h-11 rounded-xl bg-slate-50">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="home">Home</SelectItem>
                      <SelectItem value="gym">Gym</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <Button
                  type="submit"
                  data-testid="ai-generate-btn"
                  disabled={loading}
                  className="w-full bg-[#0B6E4F] hover:bg-[#095A40] text-white rounded-full h-12 font-semibold shadow-lg hover:shadow-xl transition-all mt-2"
                >
                  {loading ? (
                    <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Generating...</>
                  ) : (
                    <><Brain className="mr-2 h-4 w-4" /> Generate Plan</>
                  )}
                </Button>
              </form>

              {/* Previous Plans */}
              {plans.length > 0 && (
                <div className="mt-6 pt-6 border-t border-slate-100">
                  <p className="text-sm font-medium text-slate-700 mb-3">Previous Plans</p>
                  <div className="space-y-2 max-h-48 overflow-y-auto">
                    {plans.map((p, i) => (
                      <button
                        key={i}
                        onClick={() => loadPlan(p.plan_id)}
                        className="w-full text-left px-3 py-2 rounded-lg hover:bg-slate-50 transition-colors text-sm"
                        data-testid={`prev-plan-${i}`}
                      >
                        <p className="font-medium text-slate-700">{p.input?.fitness_goal?.replace("_", " ") || "Plan"}</p>
                        <p className="text-xs text-slate-400">{new Date(p.created_at).toLocaleDateString()}</p>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Plan Display */}
          <div className="lg:col-span-2">
            {loading && (
              <div className="bg-white border border-slate-100 rounded-2xl p-16 shadow-sm text-center" data-testid="ai-loading">
                <div className="h-16 w-16 border-4 border-[#0B6E4F] border-t-transparent rounded-full animate-spin mx-auto mb-6" />
                <h3 className="font-['Outfit'] text-xl font-semibold text-[#0F172A] mb-2">Vita AI is Working</h3>
                <p className="text-slate-500">Generating your personalized health plan...</p>
              </div>
            )}

            {!loading && !plan && (
              <div className="bg-white border border-slate-100 rounded-2xl p-16 shadow-sm text-center" data-testid="ai-empty">
                <Brain className="h-16 w-16 text-slate-200 mx-auto mb-6" />
                <h3 className="font-['Outfit'] text-xl font-semibold text-[#0F172A] mb-2">Ready to Transform?</h3>
                <p className="text-slate-500 max-w-md mx-auto">
                  Fill in your details and let Vita AI create a personalized health and fitness plan just for you.
                </p>
              </div>
            )}

            {!loading && plan?.plan_data && (
              <div className="space-y-6" data-testid="ai-plan-result">
                {/* Summary */}
                {plan.plan_data.summary && (
                  <div className="bg-[#0B6E4F] text-white rounded-2xl p-6 shadow-lg">
                    <h3 className="font-['Outfit'] text-xl font-semibold mb-2">Your Personalized Plan</h3>
                    <p className="text-white/80 leading-relaxed">{plan.plan_data.summary}</p>
                    <div className="flex gap-6 mt-4 pt-4 border-t border-white/20">
                      <div className="flex items-center gap-2">
                        <Flame className="h-4 w-4 text-[#D4F4DD]" />
                        <span className="text-sm">{plan.plan_data.daily_calorie_target || "N/A"} cal/day</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <Droplets className="h-4 w-4 text-[#D4F4DD]" />
                        <span className="text-sm">{plan.plan_data.water_intake_liters || "N/A"}L water/day</span>
                      </div>
                    </div>
                  </div>
                )}

                <Tabs defaultValue="meals" className="w-full">
                  <TabsList className="grid w-full grid-cols-3 bg-white rounded-xl p-1 shadow-sm border border-slate-100">
                    <TabsTrigger value="meals" className="rounded-lg data-[state=active]:bg-[#F2F9F6] data-[state=active]:text-[#0B6E4F] font-medium">
                      <Apple className="mr-2 h-4 w-4" /> Meal Plan
                    </TabsTrigger>
                    <TabsTrigger value="fitness" className="rounded-lg data-[state=active]:bg-[#F2F9F6] data-[state=active]:text-[#0B6E4F] font-medium">
                      <Dumbbell className="mr-2 h-4 w-4" /> Fitness
                    </TabsTrigger>
                    <TabsTrigger value="grocery" className="rounded-lg data-[state=active]:bg-[#F2F9F6] data-[state=active]:text-[#0B6E4F] font-medium">
                      <ShoppingCart className="mr-2 h-4 w-4" /> Grocery
                    </TabsTrigger>
                  </TabsList>

                  <TabsContent value="meals" className="mt-6">
                    {plan.plan_data.meal_plan?.daily_plans?.map((day, i) => (
                      <div key={i} className="bg-white border border-slate-100 rounded-xl p-6 shadow-sm mb-4" data-testid={`meal-day-${i}`}>
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="font-['Outfit'] font-semibold text-[#0F172A]">{day.day}</h4>
                          <span className="text-sm font-medium text-[#0B6E4F]">{day.total_calories} cal</span>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          {Object.entries(day.meals || {}).map(([type, meal]) => (
                            <div key={type} className="flex items-center gap-3 bg-slate-50 rounded-xl p-3">
                              <img src={getMealImg(type)} alt={type} className="w-16 h-16 object-contain rounded-lg bg-white border border-slate-100 p-1 flex-shrink-0" loading="lazy" />
                              <div className="flex-1 min-w-0">
                                <p className="text-xs font-medium text-slate-400 uppercase">{type.replace("_", " ")}</p>
                                <p className="text-sm font-medium text-[#0F172A]">{meal?.name}</p>
                                <p className="text-xs text-[#0B6E4F] font-medium mt-0.5">{meal?.calories} cal</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </TabsContent>

                  <TabsContent value="fitness" className="mt-6">
                    {plan.plan_data.fitness_program?.weekly_schedule?.map((week, wi) => (
                      <div key={wi} className="mb-6">
                        <h4 className="font-['Outfit'] font-semibold text-[#0F172A] mb-3">Week {week.week}</h4>
                        <div className="space-y-3">
                          {week.days?.map((day, di) => (
                            <div key={di} className="bg-white border border-slate-100 rounded-xl p-5 shadow-sm" data-testid={`fitness-week-${wi}-day-${di}`}>
                              <div className="flex items-center justify-between mb-3">
                                <h5 className="font-medium text-[#0F172A]">{day.day}</h5>
                                <span className="text-xs text-slate-500">{day.duration}</span>
                              </div>
                              <p className="text-sm text-[#0B6E4F] font-medium mb-3">{day.workout_type}</p>
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                {day.exercises?.map((ex, ei) => (
                                  <div key={ei} className="flex items-center gap-3 bg-slate-50 rounded-xl p-3" data-testid={`exercise-${wi}-${di}-${ei}`}>
                                    <img src={getExerciseImg(ex.name)} alt={ex.name} className="w-16 h-16 object-contain rounded-lg bg-white border border-slate-100 p-1 flex-shrink-0" loading="lazy" />
                                    <div className="flex-1 min-w-0">
                                      <p className="text-sm font-medium text-[#0F172A]">{ex.name}</p>
                                      <p className="text-xs text-[#0B6E4F] font-medium mt-0.5">{ex.sets}x{ex.reps} &bull; Rest {ex.rest}</p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </TabsContent>

                  <TabsContent value="grocery" className="mt-6">
                    <div className="bg-white border border-slate-100 rounded-xl p-6 shadow-sm" data-testid="grocery-list">
                      {plan.plan_data.grocery_list && Object.entries(plan.plan_data.grocery_list)
                        .filter(([key]) => key !== "estimated_weekly_cost")
                        .map(([category, items]) => (
                          <div key={category} className="mb-5">
                            <h4 className="font-medium text-[#0F172A] capitalize mb-2">{category}</h4>
                            <div className="flex flex-wrap gap-2">
                              {(Array.isArray(items) ? items : []).map((item, i) => (
                                <span key={i} className="bg-[#F2F9F6] text-[#0B6E4F] text-sm px-3 py-1 rounded-full">
                                  {item}
                                </span>
                              ))}
                            </div>
                          </div>
                        ))}
                      {plan.plan_data.grocery_list?.estimated_weekly_cost && (
                        <div className="mt-4 pt-4 border-t border-slate-100">
                          <p className="text-sm text-slate-600">
                            Estimated Weekly Cost: <span className="font-semibold text-[#0B6E4F]">${plan.plan_data.grocery_list.estimated_weekly_cost}</span>
                          </p>
                        </div>
                      )}
                    </div>
                  </TabsContent>
                </Tabs>
              </div>
            )}

            {!loading && plan?.raw_response && (
              <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-sm">
                <h3 className="font-['Outfit'] text-lg font-semibold text-[#0F172A] mb-4">AI Response</h3>
                <pre className="whitespace-pre-wrap text-sm text-slate-600 bg-slate-50 rounded-xl p-4 overflow-auto max-h-96">{plan.raw_response}</pre>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function VitaAI() {
  return (
    <ProtectedRoute>
      <VitaAIContent />
    </ProtectedRoute>
  );
}
